import store from '../../store'
import tokenService from '../../services/token.service'
import { uuid } from 'vue-uuid'
import { getFirstAvailableRoute } from '@/utils/getFirstAvailableRoute'

export default async (to, from, next) => {
	if (!tokenService.getDeviceIdFromStorage()) {
		tokenService.setDeviceIdToStorage(uuid.v4())
	}
	if (store.getters['auth/isAuthenticated']) {
		const target = getFirstAvailableRoute({
			appCore: store.getters['settings/appCore'],
			profile: store.getters['auth/profile']
		})

		return next(target)
	}

	if (!store.getters['settings/login']) {
		await store.dispatch('settings/getLoginSettings')
	}
	if (!store.getters['settings/baseCore']) {
		await store.dispatch('settings/getBaseCoreSettings')
	}

	return next()
}
